let cryptoJS = require('crypto-js');

export default {
  readAsBase64(file) {
    var fileReader = new FileReader();

    if (file instanceof Blob)
      return new Promise((resolve) => {
        fileReader.onloadend = () => {
          resolve(fileReader.result);
        };
        fileReader.readAsDataURL(file);
      });
    else return file;
  },
};

/**
 * calculateBufferSHA256
 * * Faz o cálculo do hash de um ArrayBuffer usando algorítmo SHA-256
 **/
export async function calculateBufferSHA256(arrayBuffer) {
  const wordArray = cryptoJS.lib.WordArray.create(arrayBuffer);
  const hash = cryptoJS.SHA256(wordArray);
  return hash;
}
